import * as React from 'react'

function SvgEnterpriseConnectionsDesktopHeroBG(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      preserveAspectRatio="none"
      viewBox="0 0 1441 478"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1440.5 80.372V372.47c-121.09-15.811-334.72-40.649-714.764-22.978C345.689 367.163.5 478 .5 478V28.303S343.448-13.615 725.736 4.576C1108.03 22.768 1440.5 80.372 1440.5 80.372z"
        fill="url(#prefix__paint0_radial_desktop_background)"
      />
      <defs>
        <radialGradient
          id="prefix__paint0_radial_desktop_background"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(-101.776 627.769 -157.83) scale(414.92 1950.46)"
        >
          <stop stopColor="#03CDFE" />
          <stop offset={0.523} stopColor="#317CE9" />
          <stop offset={0.958} stopColor="#E9315D" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export default SvgEnterpriseConnectionsDesktopHeroBG
